import React, { createContext, useContext, useState, useCallback } from 'react';
import { useBlocker } from 'react-router-dom';
import ConfirmNavigation from 'shared/dialogs/ConfirmNavigation';

const UnsavedChangesContext = createContext({
  setFormIsDirty: () => {},
  setStepLeave: () => {},
});

export const useUnsavedChanges = () => useContext(UnsavedChangesContext);

export const UnsavedChangesProvider = ({ children }) => {
  const [formIsDirty, setFormIsDirty] = useState(false);
  const [stepLeaveCallback, setStepLeaveCallback] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const shouldBlock = useCallback(
    ({ currentLocation, nextLocation }) => {
      const block = currentLocation.key !== nextLocation.key && formIsDirty;

      setShowConfirmation(block);

      return block;
    },
    [formIsDirty],
  );
  const blocker = useBlocker(shouldBlock);

  const handleClose = () => {
    setShowConfirmation(false);
    setStepLeaveCallback(null);
  };

  const handleLeave = () => {
    blocker.proceed?.();

    setFormIsDirty(false);

    stepLeaveCallback && stepLeaveCallback();

    setStepLeaveCallback(null);

    handleClose();
  };

  // forceShowConfirm - While navigating between tabs, LayoutRoute and location does not update, and useBlocker is not invoked. As a result, confirmation must be enforced manually.
  const handleLeaveStep = (callback, forceShowConfirm = false) => {
    if (formIsDirty) {
      setStepLeaveCallback(() => callback);
      forceShowConfirm && setShowConfirmation(true);
    } else {
      callback();
    }
  };

  const setFormIsDirtyCallback = useCallback((dirty) => setFormIsDirty(dirty), []);

  return (
    <UnsavedChangesContext.Provider value={{ setFormIsDirty: setFormIsDirtyCallback, setStepLeave: handleLeaveStep }}>
      {children}
      <ConfirmNavigation open={showConfirmation} onLeave={handleLeave} onClose={handleClose} />
    </UnsavedChangesContext.Provider>
  );
};
